export default __webpack_public_path__ + "static/media/games-m.e9a43078.webp";